import styled from "styled-components";

export const Slot = styled.div`
	width: 100%;
	min-height: ${({ minHeight }) => minHeight || "280px"};
	border-radius: 24px;
	overflow: hidden;
	background: ${({ dark }) => (dark ? "#111" : "#fff")};
	display: flex;
	align-items: center;
	justify-content: center;

	${({ $cover }) =>
		$cover &&
		`
		height: 100%;
		min-height: 420px;
		aspect-ratio: 16 / 10;
	`}

	${({ $fit }) =>
		$fit &&
		`
		height: auto;
		min-height: 0;
		background: transparent;
		overflow: visible;
	`}
`;

export const Placeholder = styled.div`
	width: 100%;
	min-height: ${({ minHeight }) => minHeight || "280px"};
	border: 2px dashed #2572b5;
	border-radius: 24px;
	background: rgba(255, 255, 255, 0.7);
	padding: 32px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	color: #2572b5;
	font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
	font-weight: 700;
	font-size: 18px;
	line-height: 1.35;
`;

export const Hint = styled.span`
	margin-top: 10px;
	font-size: 14px;
	font-weight: 500;
	color: #606060;
	max-width: 280px;
`;

export const MediaImage = styled.img`
	width: 100%;
	height: ${({ $cover }) => ($cover ? "100%" : "auto")};
	display: block;
	object-fit: ${({ $cover, $fit }) => ($cover ? "cover" : $fit ? "contain" : "contain")};
`;
